module.exports = __webpack_public_path__ + "media/application/images/2023/04_still-925x520-685453778805aab1d8f9d5d8b7eb0d70.png";